module.exports = __webpack_public_path__ + "img/character-body_v1.850740f5.png";